import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Text } from "../Text";
export const H1 = styled(Text).attrs({
    renderAs: "h1",
}) `
  line-height: ${size.lineHeight.h1.default};
  font-size: ${size.font.h1.default};
  color: ${color.font.headline.default};
  font-weight: bold;

  .compactMode & {
    line-height: ${size.lineHeight.h1.compact};
    font-size: ${size.font.h1.compact};
  }
`;
export default H1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSDEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9IMS9IMS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUM3RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFDO0FBRS9CLE1BQU0sQ0FBQyxNQUFNLEVBQUUsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsS0FBSyxDQUFDO0lBQ25DLFFBQVEsRUFBRSxJQUFJO0NBQ2YsQ0FBQyxDQUFBO2lCQUNlLElBQUksQ0FBQyxVQUFVLENBQUMsRUFBRSxDQUFDLE9BQU87ZUFDNUIsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsT0FBTztXQUN4QixLQUFLLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPOzs7O21CQUluQixJQUFJLENBQUMsVUFBVSxDQUFDLEVBQUUsQ0FBQyxPQUFPO2lCQUM1QixJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxPQUFPOztDQUVwQyxDQUFDO0FBRUYsZUFBZSxFQUFFLENBQUMifQ==